<div class="col-span-12 flex flex-col gap-(--spacing-layout-l)">
  <div class="flex justify-between items-center">
    <span class="text-heading-small text-primaryText">
      {{ titleKey() | translate }}
    </span>
    <div class="flex items-center gap-3">
      @if (showViewAll()) {
        <app-button
          [label]="('RM.DASHBOARD.OPEN_ACTIONS.VIEW_ALL' | translate) + ' (' + totalCount() + ')'"
          variant="text"
          endIcon="/icons/arrow-right.svg"
          (onClick)="onViewAll()"
        />
      }
    </div>
  </div>

  @if (loading()) {
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-(--spacing-layout-l)">
      @for (_ of [1, 2]; track $index) {
        <app-card rootClass="border border-primaryBorder h-full">
          <div class="flex flex-col gap-4 p-5">
            <p-skeleton height="1.5rem" width="60%" />
            <p-skeleton height="1rem" width="40%" />
            <p-skeleton height="0.75rem" width="100%" />
            <p-skeleton height="6rem" width="100%" />
          </div>
        </app-card>
      }
    </div>
  } @else if (!items().length) {
    <app-card rootClass="border border-primaryBorder">
      <div class="flex items-center justify-center min-h-[160px] text-bodyText">
        {{ emptyKey() | translate }}
      </div>
    </app-card>
  } @else {
    <div class="grid grid-cols-1 xl:grid-cols-2 gap-(--spacing-layout-l)">
      @for (item of items(); track item.id) {
        <app-card rootClass="border border-primaryBorder h-full" bodyClass="h-full" contentClass="h-full flex flex-col">
          <div class="flex flex-col flex-1">
            <div class="p-5 flex justify-between items-start shrink-0">
              <div class="flex flex-col justify-center min-w-0">
                <span class="text-subheading-large text-headingText truncate">{{ item.name }}</span>
                @if (item.assetClass != null) {
                  <div class="flex items-center gap-2">
                    <svg-icon [src]="getAssetClassIcon(item.assetClass)" svgClass="w-4 h-4"></svg-icon>
                    <span class="text-body-large text-bodyText">{{ getAssetClassLabel(item.assetClass) }}</span>
                  </div>
                }
                @if (item.closeDate) {
                  <span class="text-body-large text-bodyText">
                    Closing date: {{ item.closeDate | customDate }}
                  </span>
                }
              </div>
              <div class="flex items-center gap-2 shrink-0">
                @if (getStatusLabel(item.status); as statusLabel) {
                  <app-tag [value]="statusLabel" [severity]="getStatusSeverity(item.status)" />
                }
                <app-tag [value]="daysRemainingLabel(item)" [severity]="daysRemainingSeverity(item)" />
              </div>
            </div>

            <div class="p-5 flex flex-col gap-4 pt-0 flex-1">
              <div class="flex flex-col justify-center gap-2">
                <div class="flex items-center justify-between">
                  <span class="text-subheading-medium text-headingText">Raised</span>
                  <span class="text-subheading-medium text-headingText">Target</span>
                </div>
                <div class="flex items-center justify-between">
                  <app-currency-display
                    class="text-body-large text-bodyText"
                    [value]="item.raisedAmount"
                    [currencyCode]="item.currency || 'USD'"
                    [compact]="true"
                  />
                  @if (item.targetAmount != null) {
                    <app-currency-display
                      class="text-body-large text-bodyText"
                      [value]="item.targetAmount"
                      [currencyCode]="item.currency || 'USD'"
                      [compact]="true"
                    />
                  } @else {
                    <span class="text-body-large text-bodyText">—</span>
                  }
                </div>
                <app-progress-bar [value]="item.progressPercent" />
              </div>

              <a [routerLink]="getDealDetailsLink(item)" class="w-full mt-auto">
                <app-button
                  [label]="'View Details'"
                  [styleClass]="'w-full'"
                  endIcon="/icons/eye.svg"
                  variant="secondary"
                />
              </a>
            </div>
          </div>
        </app-card>
      }
    </div>
  }
</div>
